import { useContext } from "react";
import { getApi } from "@beeldit/core/helpers/api";
import { SendToAccountingActionContext } from "./SendToAccountingActionContext";

function useSendToAccounting() {
  const { setLoading } = useContext(SendToAccountingActionContext);

  return async (onSuccess: () => void) => {
    setLoading(true);
    try {
      await getApi().post(
        "/invoices/send-to-accounting",
        {}
      );

      onSuccess();
    } catch (error: any) {
      console.error("Error sending to accounting:", error);
      alert(error.response?.data?.message || "Error al enviar a la gestoría");
    } finally {
      setLoading(false);
    }
  };
}

export default useSendToAccounting;
